import cx from "classnames";
import React from "react";
import styles from "./Badge.scss";

export const Badge = ({ children, type }) => (
  <span className={cx(styles.Badge, styles[type] || styles.default)}>{children}</span>
);
